import Row from '../Row';
import NestedControlBlock from '../NestedControlBlock';
import MarkerIconStyleProvider from '../../../providers/MarkerIconStyleProvider';
import * as ids from '../../../layerIdStrings';

export default [
    {
        component: Row,
        props: {
            id: 'corpus_dialekt',
            type: 'markers',
            category: 'layer',
            className: 'js-marker-layer-wrapper js-layer',
            name: 'Korpus <strong>DIALEKT</strong>',
            initial: false,
            icon: false,
        }
    },
    {
        component: NestedControlBlock,
        props: {
            children: [
                {
                    component: Row,
                    props: {
                        id: 'dialekt_record_place',
                        type: 'markers',
                        category: 'layer',
                        className: 'js-marker-layer-wrapper js-layer',
                        value: 'dialekt_record_place',
                        name: 'Místo nahrávání',
                        initial: false,
                        icon: {
                            color: MarkerIconStyleProvider.getColor('dialekt_record_place'),
                        },
                    }
                },
                {
                    component: Row,
                    props: {
                        id: 'dialekt_examples',
                        type: 'markers',
                        category: 'layer',
                        className: 'js-marker-layer-wrapper js-layer',
                        value: 'dialekt_examples',
                        name: 'Ukázky nářečních promluv',
                        initial: true,
                        icon: {
                            color: MarkerIconStyleProvider.getColor('dialekt_examples'),
                        },
                    }
                },
                {
                    component: Row,
                    props: {
                        id: 'dialekt_record_old',
                        type: 'markers',
                        category: 'layer',
                        className: 'js-marker-layer-wrapper js-layer',
                        value: 'dialekt_record_old',
                        name: 'Nahrávky ze staré vrstvy<br>(50. až 80. léta 20. stol.)',
                        initial: false,
                        icon: {
                            color: MarkerIconStyleProvider.getColor('dialekt_record_old'),
                        },
                    }
                },
                {
                    component: Row,
                    props: {
                        id: 'dialekt_record_new',
                        type: 'markers',
                        category: 'layer',
                        className: 'js-marker-layer-wrapper js-layer',
                        value: 'dialekt_record_new',
                        name: 'Nahrávky z nové vrstvy<br>(od 90. let 20. stol. do současnosti)',
                        initial: false,
                        icon: {
                            color: MarkerIconStyleProvider.getColor('dialekt_record_new'),
                        },
                    }
                },
                {
                    component: Row,
                    props: {
                        id: 'dialekt_record_place_all',
                        type: 'markers',
                        category: 'layer',
                        className: 'js-marker-layer-wrapper js-layer',
                        value: 'dialekt_record_place_all',
                        name: 'Celkový sběr nářečního materiálu<br>(místo nahrávání)',
                        initial: false,
                        icon: {
                            color: MarkerIconStyleProvider.getColor('dialekt_record_place_all'),
                        },
                    }
                },
                {
                    component: Row,
                    props: {
                        id: 'dialekt_speaker_place_all',
                        type: 'markers',
                        category: 'layer',
                        className: 'js-marker-layer-wrapper js-layer',
                        value: 'dialekt_speaker_place_all',
                        name: 'Celkový sběr nářečního materiálu<br>(mluvčí)',
                        initial: false,
                        icon: {
                            color: MarkerIconStyleProvider.getColor('dialekt_speaker_place_all'),
                        },
                    }
                },
                {
                    component: Row,
                    props: {
                        id: 'dialekt_record_cja',
                        type: 'markers',
                        category: 'layer',
                        className: 'js-marker-layer-wrapper js-layer',
                        value: 'dialekt_record_cja',
                        name: 'Nahrávky z Českého jazykového atlasu',
                        initial: false,
                        icon: {
                            color: MarkerIconStyleProvider.getColor('dialekt_record_cja'),
                        },
                    }
                },
            ]
        }
    },
    {
        component: Row,
        props: {
            id: 'cja_place',
            type: 'markers',
            category: 'layer',
            chboxClassName: 'js-show-search-button',
            className: 'js-marker-layer-wrapper js-layer',
            value: 'cja_place',
            name: 'Zkoumané lokality Českého jazykového atlasu',
            initial: false,
            icon: {
                color: MarkerIconStyleProvider.getColor('cja_place'),
            },
        }
    },
    {
        component: Row,
        props: {
            id: 'corpus_ortofon',
            type: 'markers',
            category: 'layer',
            className: 'js-marker-layer-wrapper js-layer',
            name: 'Korpus <strong>ORTOFON</strong>',
            initial: false,
            icon: false,
        }
    },
    {
        component: NestedControlBlock,
        props: {
            children: [
                {
                    component: Row,
                    props: {
                        id: 'ortofon_speaker_place',
                        type: 'markers',
                        category: 'layer',
                        className: 'js-marker-layer-wrapper js-layer',
                        value: 'ortofon_speaker_place',
                        name: 'Místo pobytu mluvčího do 15 let',
                        initial: false,
                        icon: {
                            color: MarkerIconStyleProvider.getColor('ortofon_speaker_place'),
                        },
                    }
                },
                {
                    component: Row,
                    props: {
                        id: 'ortofon_examples',
                        type: 'markers',
                        category: 'layer',
                        className: 'js-marker-layer-wrapper js-layer',
                        value: 'ortofon_examples',
                        name: 'Ukázky rozhovorů',
                        initial: true,
                        icon: {
                            color: MarkerIconStyleProvider.getColor('ortofon_examples'),
                        },
                    }
                },
            ]
        }
    },
    {
        component: Row,
        props: {
            id: 'corpus_oral',
            type: 'markers',
            category: 'layer',
            className: 'js-marker-layer-wrapper js-layer',
            name: 'Korpus <strong>ORAL</strong>',
            initial: false,
            icon: false,
        }
    },
    {
        component: NestedControlBlock,
        props: {
            children: [
                {
                    component: Row,
                    props: {
                        id: 'oral_speaker_place',
                        type: 'markers',
                        category: 'layer',
                        className: 'js-marker-layer-wrapper js-layer',
                        value: 'oral_speaker_place',
                        name: 'Místo narození mluvčího',
                        initial: false,
                        icon: {
                            color: MarkerIconStyleProvider.getColor('oral_speaker_place'),
                        },
                    }
                },
                {
                    component: Row,
                    props: {
                        id: 'oral_examples',
                        type: 'markers',
                        category: 'layer',
                        className: 'js-marker-layer-wrapper js-layer',
                        value: 'oral_examples',
                        name: 'Ukázky rozhovorů',
                        initial: true,
                        icon: {
                            color: MarkerIconStyleProvider.getColor('oral_examples'),
                        },
                    }
                },
            ]
        }
    },
];
